import {getMediaUrl} from '@/shared/lib/getMediaUrl';

export const LOGIN_MEMBERS_CARD = [
  {
    image: getMediaUrl('landing/Josh.webp'),
    text: `“Genesis really is just a dream come true for me and the person I've been looking for my entire life!”`,
    name: 'Josh',
    firstCode: 'CO',
    secondCode: 'US',
  },
  {
    image: getMediaUrl('landing/Mona.webp'),
    text: '“Thanks to Bumpy, I have found my soulmate, my forever partner.”',
    name: 'Mona',
    firstCode: 'IN',
    secondCode: 'PH',
  },
  {
    image: getMediaUrl('landing/Damian.webp'),
    text: '“It all began with a BUMP, and from there our conversations flowed endlessly.”',
    name: 'Damian',
    firstCode: 'AR',
    secondCode: 'CO',
  },
  {
    image: getMediaUrl('landing/Shakila.webp'),
    text: `“He is from Brazil and I'm from Sri Lanka and we meet on Bumpy. He cross the world for me.”`,
    name: 'Shakila',
    firstCode: 'LK',
    secondCode: 'BR',
  },
];
